module.exports = __webpack_public_path__ + "static/aselsanNews-428867a14bf3c2ed95ab0887361abdaf.jpg";